import script from "./MGDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGDialog.vue?vue&type=script&setup=true&lang=ts"

import "./MGDialog.vue?vue&type=style&index=0&id=206d5eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206d5eea"]])

export default __exports__